import React from 'react';
import List from './List';
import Text from './Text';

const MAX_ITEMS = 5;

interface Props {
    value: string[];
    onChange: (items: string[]) => void;
    placeholder?: string;
    fill?: boolean;
}

interface State {
    items: string[];
}

class TextList extends React.Component<Props, State> {
    inputs: React.RefObject<HTMLInputElement>[];

    constructor(props: Props) {
        super(props);

        this.state = {
            items: props.value,
        };
    }

    UNSAFE_componentWillReceiveProps(props: Props) {
        this.setState({
            items: props.value,
        });
    }

    handleKeyPress = (idx: number, e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            const input = this.inputs[idx + 1];
            if (input && input.current) {
                input.current.focus();
            }
        }
    };

    onChange = (idx: number, value: string) => {
        this.setState(
            state => {
                const items = [...state.items];

                if (value.length) {
                    items[idx] = value;
                } else {
                    items.splice(idx, 1);
                }

                return {
                    items,
                };
            },
            () => {
                this.props.onChange(this.state.items);
            }
        );
    };

    get items() {
        if (this.state.items.length >= MAX_ITEMS) {
            return this.state.items;
        } else {
            return [...this.state.items, ''];
        }
    }

    render() {
        this.inputs = [];

        return (
            <List spacing="small">
                {this.items.map((item, idx) => {
                    const ref = React.createRef<HTMLInputElement>();
                    this.inputs.push(ref);

                    return (
                        <Text
                            fill={this.props.fill}
                            forwardedRef={ref}
                            key={idx}
                            placeholder={idx === 0 ? this.props.placeholder : ''}
                            onChange={this.onChange.bind(this, idx)}
                            onKeyPress={this.handleKeyPress.bind(this, idx)}
                            value={item}
                        />
                    );
                })}
            </List>
        );
    }
}

export default TextList;
